module.exports = __webpack_public_path__ + "static/pie3-f85ec291b07e8c426ca092e0f0681fcc.png";